"use strict";export var MediaType=(t=>(t.IMAGE="image",t.VIDEO="video",t))(MediaType||{});
//# sourceMappingURL=CoachmarkItem.js.map
